export default {
  shareTitle: 'Share',
  download: 'Download',
  welcome: 'Welcome',
  invitation: 'We sincerely invite you to visit',
  session: 'The {num}th session',
  scanQrCode: 'Long press to scan the QR code and get your admission ticket',
  cancel: 'Cancel',
  downloadSuccess: 'Download successful!'
}
